import { takeLatest, call, put } from "redux-saga/effects";
import { preLoginFailure, preLoginSuccess } from "../action/preLoginAction";
import { returnErrors, clearErrors } from "../action/errorAction";
import * as _api from "../../api";
import * as types from "../types";

function* asyncPreLoginSaga(action) {
  try {
    yield put(clearErrors());
    let otpData = yield call(_api.getPreLogin, {
      requestUser: action.payload.requestUser,
    });
    yield put(preLoginSuccess({ otpData }));
  } catch (e) {
    const msg = e.response?.data?.message || e.message;
    yield put(returnErrors({ msg, status: true }));
    yield put(preLoginFailure({ error: { message: msg } }));
  }
}
export default function* preLoginSaga() {
  yield takeLatest(types.PRE_LOGIN_REQUEST, asyncPreLoginSaga);
}
